import React, { Component } from 'react'
import { Button, Popover, Position, Tag } from '@blueprintjs/core';
import ListPicker from 'components/ListPicker';
import SearchDateRangePicker from 'components/SearchDateRangePicker';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import moment from 'moment-timezone';
import { formatDateRange } from 'helpers/dateRange';
import BookingModal from '../../pages/bookings/booking-modal.js';
import SearchFiltersToolbar from 'components/SearchFiltersToolbar';
import SearchFiltersSearchButton from 'components/SearchFiltersSearchButton';

const options = [
  { label: 'Draft', value: 'draft', selected: false },
  { label: 'Confirmed', value: 'confirmed', selected: false }
];

@inject('store', 'viewStore', 'bookingStore') @observer
class BookingSearch extends Component {
  @observable startDate = null;
  @observable endDate = null;

  @observable openBookingModal = false;
  @observable bookingModalKey = 0;

  @action
  search() {
    let viewStore = this.props.viewStore;
    viewStore.bookingSearch.page = 1;
    this.props.viewStore.bookings();
  }

  @action
  onSearchTermChange(e) {
    let {
      props: {
        viewStore: {
          bookingSearch
        }
      }
    } = this;
    this.props.viewStore.bookingSearch = {
      ...bookingSearch,
      term: e.target.value
    }
  }

  @action
  onBookingStatusChange(selections) {
    let selectedValues = selections.map((status) => status.value);
    let {
      props: {
        viewStore: {
          bookingSearch
        }
      }
    } = this;
    this.props.viewStore.bookingSearch = {
      ...bookingSearch,
      where: {
        ...bookingSearch.where,
        status: selectedValues
      }
    }
  }

  @action
  onDateRangeChange(range) {
    let {
      props: {
        viewStore: {
          bookingSearch
        }
      }
    } = this;
    this.props.viewStore.bookingSearch = {
      ...bookingSearch,
      where: {
        ...bookingSearch.where,
        start_date: { 
          gte: moment(range[0]).startOf('day').unix(),
          lte: moment(range[1]).endOf('day').unix()
        }
      }
    }
    this.startDate = range[0];
    this.endDate = range[1];
    this.search()
  }

  onEnter(event) {
    if (event.key === "Enter") {
      this.search()
    }
  }


  // Each New booking starts from a blank booking and a freshly mounted dialog
  // (it keeps totals and choices in its own state), so nothing carries over.
  onOpenBookingModal() {
    this.props.bookingStore.resetBooking();
    this.bookingModalKey += 1;
    this.openBookingModal = true;
  }

  onCloseBookingModal(){
    this.openBookingModal = false;
  }

  onSuccessBookingModal() {
    this.openBookingModal = false;
  }






  
  render() {
    let {
      props: {
        viewStore,
        viewStore: {
          bookingSearch: { 
            term, 
            where 
          }
        }
      }
    } = this;

    if(term == '*'){
      term = '';
    }

    let startDate = moment.unix(parseInt(where.start_date.gte)).toDate();
    let endDate = moment.unix(parseInt(where.start_date.lte)).toDate();

    return (
      <SearchFiltersToolbar
        searchButton={
          <SearchFiltersSearchButton onClick={this.search.bind(this)} />
        }
        actions={
          <>
            <Button className="action-btn" icon="plus" text="New booking" onClick={this.onOpenBookingModal.bind(this)} />
            <Button className="action-btn" icon="share" text="Share booking form" onClick={() => viewStore.bookingShare()} />
          </>
        }
        navExtra={
          <>
            <BookingModal
              key={this.bookingModalKey}
              isOpen={this.openBookingModal}
              onClose={this.onCloseBookingModal.bind(this)}
              onSuccess={this.onSuccessBookingModal.bind(this)}
            />
          </>
        }
      >
        <Popover
          minimal={true}
          content={
            <SearchDateRangePicker
              startDate={startDate}
              endDate={endDate}
              onChange={this.onDateRangeChange.bind(this)}
            />
          }
          position={Position.BOTTOM_LEFT}
          usePortal={true} >
          <Button
            className="filter-date"
            icon="calendar"
            rightIcon="caret-down"
            text={formatDateRange(startDate, endDate)}
          />
        </Popover>

        <input
          type="text"
          className="bp3-input search-filters-toolbar__field-wide"
          placeholder="First Name, Last Name, Email, Phone No."
          onChange={this.onSearchTermChange.bind(this)}
          defaultValue={term}
          onKeyPress={this.onEnter.bind(this)}
        />

        <Popover
          minimal={true}
          content={
            <ListPicker
              selectedOptions={(where && where.status) || []}
              options={options}
              onChange={this.onBookingStatusChange.bind(this)}
            />
          }
          position={Position.BOTTOM_LEFT}
          usePortal={true} >
          <Button rightIcon='caret-down'>
            Status
            <span>&nbsp;</span>
            <Tag minimal={true} round={true}>{(where && where.status && where.status.length) || 0}</Tag>
          </Button>
        </Popover>
      </SearchFiltersToolbar>
    )
  }
}

export default BookingSearch;